<ng-container *ngIf="project && !projectActivitiesIsLoading && !punchCheckListIsLoading">
    <div class="dialog-header">
        <div class="header-title">
            <div class="header-icon" *ngIf="showOptions" (click)="toggleOptions()" style="margin-right: 0.5em;">
                <mat-icon>arrow_back</mat-icon>
            </div>
            <div class="plashka-number" *ngIf="!showOptions">{{ project.number }}</div>
            <span class="project-name">{{ project.name }}</span>
            <div class="cv-sync-block" [ngClass]="{'has-sync': project.hasCvFile, 'tooltip-active': showCvTooltip}"
                 (click)="toggleCvTooltip($event)"
            >
                CV
                <div class="cv-tooltip" *ngIf="showCvTooltip">
                    {{project.hasCvFile ? (project.lastCvSync | date:'MMM d, y, h:mm a') : 'No sync with CV file'}}
                </div>
            </div>
        </div>

        <div class="buttons-block">
            <button class="header-button" mat-button (click)="openLastDrawing()">DRAWING</button>
            <button class="header-button" mat-button (click)="openProposal()"
                    *ngIf="currentUser.canSeeProposal">PROPOSAL
            </button>
        </div>

        <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <div class="middle-content">
        <div class="info-block" *ngIf="!showOptions">

            <div class="info-row row-block">
                <div class="comments-row-title row-title">
                    <div class="title-icon">
                        <mat-icon>info</mat-icon>
                    </div>
                    Project Info
                    <div style="flex: 1;">

                    </div>
                    <div class="title-icon" style="margin-right: 0.75em;" *ngIf="isMobile" (click)="toggleOptions()">
                        <mat-icon>settings</mat-icon>
                    </div>
                </div>

                <div class="info-block div-block">
                    <app-project-info-block [project]="project"></app-project-info-block>
                </div>

            </div>


            <div class="customer-row row-block">
                <div class="customer-row-title row-title">
                    <div class="title-icon">
                        <mat-icon>person</mat-icon>
                    </div>
                    Customer Billing Info
                </div>

                <div class="customer-block div-block">
                    <app-customer-block [project]="project"></app-customer-block>
                </div>

            </div>

            <ng-container *ngIf="project.notificationContacts?.length > 0">
                <div class="customer-row row-block" *ngFor="let nfsContact of project.notificationContacts">
                    <div class="customer-row-title row-title">
                        <div class="title-icon">
                            <mat-icon>email</mat-icon>
                        </div>
                        Project Contact Info
                    </div>

                    <div class="customer-block div-block">
                        <app-contact-info-block [nfsContact]="nfsContact"></app-contact-info-block>
                    </div>

                </div>

            </ng-container>

            <ng-container *ngIf="project.customer?.contacts?.length && !project.notificationContacts?.length">
                <div class="customer-brick">
                    <div class="customer-row-title row-title">
                        <div class="title-icon">
                            <mat-icon>email</mat-icon>
                        </div>
                        Project Contact Info
                        <i class="pi pi-info-circle" style="margin-left: 0.3em"
                           pTooltip="Select contact in customer menu" tooltipPosition="bottom"></i>
                    </div>

                    <div class="customer-block div-block">
                        <app-contact-info-block [nfsContact]="nfsContactTemplate"></app-contact-info-block>
                    </div>
                </div>
            </ng-container>

            <div class="history-row row-block">
                <div class="history-block div-block">
                    <app-client-messages-block [projectId]="project.id"></app-client-messages-block>
                </div>
            </div>

            <app-alerts-row class="alert-row row-block"></app-alerts-row>

            <div class="statuses-row row-block">
                <div class="status-row-title row-title">
                    <div class="title-icon">
                        <mat-icon>format_list_bulleted</mat-icon>
                    </div>
                    Activities


                    <button mat-button (click)="recalculateAllActivities()" class="delete-activities-button"
                            *ngIf="project.activities.length > 0">Recalculate
                        actvities
                    </button>
                    <button mat-button (click)="deleteAllActivities()" class="delete-activities-button"
                            *ngIf="project.activities.length > 0">Delete all
                        actvities
                    </button>

                    <p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="project-panel-confirm-dialog">
                    </p-confirmDialog>
                </div>

                <div class="status-block div-block">
                    <div class="activities-exist" *ngIf="project.activities && project.activities.length > 0">
                        <div class="activities">
                            <app-mobile-activities [projectActivities]="project.activities" [projectId]="project.id">
                            </app-mobile-activities>
                        </div>
                    </div>

                    <div class="no-activities-block" *ngIf="!project.activities || project.activities.length <= 0">
                        <div class="punchlist-title">No any Acitivities</div>
                    </div>
                    <div class="new-activity-block">
                        <button mat-button class="add-activity-button" (click)="openProjectActivityWindow()">
                            <mat-icon>add</mat-icon>
                            <div class="button-title">Add new project activity</div>
                        </button>
                    </div>

                </div>
            </div>
            <div class="punchlists-row row-block">

                <div class="punchlists-block div-block">
                    <div class="checkitems-exist" *ngIf="checkLists">
                        <app-checklist-block [checkLists]="checkLists" [projectId]="project.id"
                                             [projectName]="project.name">
                        </app-checklist-block>
                    </div>

                    <div class="no-items-block" *ngIf="!checkLists">
                        <div class="punchlist-title">No any punch items</div>
                    </div>
                </div>

            </div>

            <div class="history-row row-block">
                <div class="history-block div-block">
                    <app-tasks-block [projectId]="project.id" [projectName]="project.name"></app-tasks-block>
                </div>
            </div>

            <div class="files-row row-block">
                <div class="files-row-title row-title">
                    <div class="title-icon">
                        <mat-icon>attach_file</mat-icon>
                    </div>
                    Files
                </div>

                <div class="files-block div-block">
                    <app-files-block [project]="project"></app-files-block>
                </div>

            </div>

            <div class="comments-row row-block">
                <div class="comments-row-title row-title">
                    <div class="title-icon">
                        <mat-icon>notes</mat-icon>
                    </div>
                    Project comments
                </div>

                <div class="comments-block div-block">
                    <app-activities-block [project]="project"></app-activities-block>
                </div>

            </div>

            <!-- <div class="history-row row-block">
              <div class="history-block div-block">
                <app-cabinets-statuses-block [activityType]="'assembly'" [project]="project">
                </app-cabinets-statuses-block>
              </div>
            </div>

            <div class="history-row row-block">
              <div class="history-block div-block">
                <app-cabinets-statuses-block [activityType]="'qualityControl'" [project]="project">
                </app-cabinets-statuses-block>
              </div>
            </div>

            <div class="history-row row-block">
              <div class="history-block div-block">
                <app-cabinets-statuses-block [activityType]="'jobDelivery'" [project]="project">
                </app-cabinets-statuses-block>
              </div>
            </div> -->

            <div class="history-row row-block">
                <div class="history-block div-block">
                    <app-history-block [projectId]="project.id"></app-history-block>
                </div>
            </div>
        </div>
        <div class="panel-block" *ngIf="!isMobile || showOptions">
            <app-project-panel></app-project-panel>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!project || projectActivitiesIsLoading || punchCheckListIsLoading">
    <lib-progress-spinner></lib-progress-spinner>
</ng-container>
